import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ReactComponent as Close } from "../../assets/modalCloseIcon.svg";

import { Loader, Tabs } from '@mantine/core'
import {
  IconPlaneArrival,
  IconPlaneDeparture,
  IconRotateClockwise,
  IconTemperatureSun,
} from "@tabler/icons-react";
import moment from 'moment'

import FlightMap from '../FlightTracking/FlightMap'
import FlightRouteCard from './FlightRouteCard'
import AltitudeGraph from './AltitudeGraph';
import base_url from '../../api/bootapi';
import * as Ably from 'ably';
import { ungzip } from "pako";

 let ably = new Ably.Realtime({ key: "qlt41Q.2h6qug:R1FagOtYTS6H1DGFP3XBvSKezDqyG2gAnvX3o2X3Nis", recover: (_, cb) => {
    cb(true);
 },
 });
  

const FlightStatsDetails = () => {

    useEffect(()=>{window.scrollTo(0,0)},[])


  const location = useLocation();
// console.log(location.state)
  const { flightLiveDetails, indivisualFlight } = location.state || {};

//  console.log("Flight Details ===============> ",indivisualFlight)
   const [flightData, setFlightData] = useState([]);
  const [airports, setAirports] = useState([]);
  
   const [toAirport, setToAirport] = useState([]);
    const [fromAirport, setFromAirport] = useState([]);
  const [flightStatus, setFlightStatus] = useState(null);
   const [currentFlightPosition, setCurrentFlightPosition] = useState([]);
    const [heading, setHeading] = useState(0);
    const [departureCode, setDepartureCode] = useState(null);
  const [arrivalCode, setArrivalCode] = useState(null);
  
  
  
  const [flightDetails,setFlightDetails]=useState(flightLiveDetails)

  
  
    useEffect(() => {
      if (airports.length > 0) {
        const toAirportIndex = airports.find(
          (airport) => airport.fs === arrivalCode
        );
  
       
  
        const fromAirportIndex = airports.find(
          (airport) => airport.fs === departureCode
        );
  
        if (toAirportIndex) {
          setToAirport(toAirportIndex);
        }
  
        if (fromAirportIndex) {
          setFromAirport(fromAirportIndex);
        }
  
        // console.log("fromAirportIndex", fromAirportIndex);
        // console.log("departureCode", departureCode);
      }
    }, [airports]);
  
  const [flightHeading, setFlightHeading] = useState(null);
  const [flightSpeed, setFlightSpeed] = useState(null);
  const [flightAltitude, setFlightAltitude] = useState(null);



function calculateDistance(points) {
  try {
    // Validate array
    if (!Array.isArray(points) || points.length !== 2) return null;

    const [p1, p2] = points;

    // Validate coordinates
    if (
      !p1?.latitude || !p1?.longitude ||
      !p2?.latitude || !p2?.longitude
    ) return null;

    // Ensure values are numbers
    const lat1 = Number(p1.latitude);
    const lon1 = Number(p1.longitude);
    const lat2 = Number(p2.latitude);
    const lon2 = Number(p2.longitude);

    if ([lat1, lon1, lat2, lon2].some(isNaN)) return null;

    const R = 6371; // Earth radius in KM

    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distanceKm = R * c;
    const distanceMiles = distanceKm * 0.621371;

    return distanceMiles;
  } catch (e) {
    return null;
  }
  }
  
  function getDuration(start, end) {
  if (!start || !end) return null;

  const s = new Date(start);
  const e = new Date(end);

  const diffMs = e - s;
  if (isNaN(diffMs) || diffMs < 0) return null;

  const mins = Math.floor(diffMs / 1000 / 60);
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;

  return `${hours}h ${minutes}m`;
  }
  
  function calculateFlightDurations(departure, arrival, current) {

    // console.log(departure,arrival,current)
  if (!departure || !arrival || !current) return null;

  const dep = new Date(departure);
  const arr = new Date(arrival);
  const cur = new Date(current);

  if ([dep, arr, cur].some(d => isNaN(d))) return null;

  const totalMs = arr - dep;
  const traveledMs = Math.max(0, cur - dep);
  const remainingMs = Math.max(0, arr - cur);

  const formatDuration = (ms) => {
    if (ms <= 0) return "0h 0m";
    const mins = Math.floor(ms / 60000);
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    return `${hours}h ${minutes}m`;
  };

  return {
    totalDuration: formatDuration(totalMs),
    traveledDuration: formatDuration(traveledMs),
    remainingDuration: formatDuration(remainingMs),
  };
}


  const [totalDuration, setTotalDuration] = useState(null);
  const [totalTraveledDuration, setTotalTraveledDuration] = useState(null);
  const [remainingDuration,setRemainingDuration]=useState(null)

  
  const [distance, setDistance] = useState(null)
  const [totalTraveledDistance, setTotalTraveledDistance] = useState(null)
  const [remainingDistance, setRemainingDistance] = useState(null)

  
  const [progress,setProgress]=useState(100)
  
    const handleViewMore = async(flightLiveDetails) => {
  

     
    
      if (flightLiveDetails.error) {

        return
      }

      //  console.log("Flight Live Tracking Details ============> ",flightLiveDetails)
          setFlightData(flightLiveDetails?.appendix?.airports);
      const responseAirports = flightLiveDetails?.appendix?.airports;
      const departureAirportFsCode = flightLiveDetails?.flightTrack?.departureAirportFsCode ?? null;
      const arrivalAirportFsCode = flightLiveDetails?.flightTrack?.arrivalAirportFsCode ?? null;



        if (responseAirports && responseAirports.length > 0) {
          const mappedAirports = responseAirports.map((airport) => ({
            ...airport,
            lat: airport.latitude,
            lng: airport.longitude,
          }));

          setAirports(mappedAirports);
        } else {
          setAirports([]);
      }

      if (responseAirports && responseAirports.length > 0 && (indivisualFlight?.status === "A" || indivisualFlight?.status === "L")) {
         
        
          const points = responseAirports.map((airport) => ({
           
            latitude: airport.latitude,
            longitude: airport.longitude,
          }));
         
        const distance = calculateDistance(points)
        
        


         if (distance) {
           
           setDistance(Math.floor(distance))
         }

        const lastPosition = flightLiveDetails?.flightTrack?.positions?.[0] || null;
      



         if (lastPosition) {
           const departurePoint = responseAirports.filter(airport => airport?.fs === departureAirportFsCode)?.map((airport) => ({
           
             latitude: airport.latitude,
             longitude: airport.longitude,
           }));


          const departureAirport = responseAirports.find(
  airport => airport?.fs === departureAirportFsCode
);

           const departureUtcOffsetHours = departureAirport?.utcOffsetHours;
           
           const arrivalAirport = responseAirports.find(
  airport => airport?.fs === arrivalAirportFsCode
);

const arrivalUtcOffsetHours = arrivalAirport?.utcOffsetHours;


            const time = calculateWithOffsetHours(indivisualFlight?.actual_departure || indivisualFlight?.estimated_departure || indivisualFlight?.departure_time,departureUtcOffsetHours, indivisualFlight?.actual_arrival || indivisualFlight?.estimated_arrival || indivisualFlight?.arrival_time,arrivalUtcOffsetHours, lastPosition?.date)

          //  console.log("Total Times ============= > ", time)

           if (indivisualFlight?.status === "L") {
              setTotalDuration(time?.totalDuration ?? null)
           setTotalTraveledDuration(time?.totalDuration ?? null)
           setRemainingDuration('0m')
           } else {
              setTotalDuration(time?.totalDuration ?? null)
           setTotalTraveledDuration(time?.travelled ?? null)
           setRemainingDuration(time?.remaining ?? null)
           }
          
           

          
           const totalTreaveledPoints = [...departurePoint, { latitude: lastPosition?.lat, longitude: lastPosition?.lon }]
           
           let totalTraveledDistance = calculateDistance(totalTreaveledPoints);

           totalTraveledDistance = totalTraveledDistance > distance ? distance :totalTraveledDistance

           let remainingDistance = distance - totalTraveledDistance;
           remainingDistance = remainingDistance < 0 ? 0 : remainingDistance
           const progress = Math.floor((totalTraveledDistance / distance) * 100);
          //  console.log(progress)

           setProgress(progress)
        
            setTotalTraveledDistance(Math.floor(totalTraveledDistance))
            setRemainingDistance(Math.floor(remainingDistance))
        
         }

         
         
        }
     
  
    
       
        const currentFlightPosition =
        flightLiveDetails?.flightTrack?.positions || [];
      
    
      const heading = flightLiveDetails?.flightTrack?.heading?.toFixed(2) || 0;
      
     

      setFlightAltitude(currentFlightPosition[0]?.altitudeFt || 0);
      setFlightSpeed(currentFlightPosition[0]?.speedMph || 0);
       setHeading(heading || 0);
        setCurrentFlightPosition(currentFlightPosition);
      
     
    
    


  };
  

  
   const [backdropOpen,setBackdropOpen]=useState(false)
  const handleRefresh = () => {
      

     setBackdropOpen(true)
  
  
      axios.get(`${base_url.api1}/users/org_flight_stats_live_tracking?flight_id=${indivisualFlight?.flight_id}`)
        .then((response) => {
          const flight = response.data.Flight_Track;
        setBackdropOpen(false)
          if (flight) {
           setFlightDetails(flight)
          }
        
        })
        
        .catch((error) => {
          setBackdropOpen(false)
         
          console.error("Error fetching flight details:", error);
        });
      
      
  
  
    };

  useEffect(() => {

    
    
    
    if (flightDetails) {
      
      handleViewMore(flightDetails)
    }
  }, [flightDetails])


const base64ToObject = async(b64) => {
  const strData = atob(b64);                         // base64 → binary string

  const charData = strData.split('').map(x => x.charCodeAt(0));
  const binData  = new Uint8Array(charData);         // binary string → Uint8Array

  const data = ungzip(binData, { to: 'string' });    // gunzip → string

  return JSON.parse(data);                           // string → JSON object
};

useEffect(() => {
  if (indivisualFlight?.status !== "A") return;
  if (!indivisualFlight?.flight_id) return;

 
  let ch;


  const fetchChannel = async () => {
    try {
      const res = await axios.post(
        `${base_url.api1}/users/create_or_get_channel`,
        { flight_id: indivisualFlight.flight_id }
      );

      const { channel } = res.data;

      if (ably.connection.state !== "connected") {
        ably.connect();
      }

      ch = ably.channels.get(channel);

      // subscribe
      ch.subscribe(async(msg) => {
      

        
       const flightDetails =  await base64ToObject(msg.data)
      console.log("Websocket Data:", flightDetails);
        if (flightDetails) {
  
          setFlightDetails(flightDetails);
}
      });
    } catch (err) {
      console.log("Error fetching channel:", err);
    }
  };

  fetchChannel();

  return () => {
    if (ch) {
      ch.unsubscribe();

      ch.detach((err) => {
        if (!err) {
          ably.channels.release(ch.name);
        } else {
          console.log("Failed to detach channel:", err);
        }
      });
    }
  };
}, [indivisualFlight?.flight_id, indivisualFlight?.status]);




  useEffect(() => {
  if (indivisualFlight?.status !== "A") return;  // ❗ Only when active flight
  if (!indivisualFlight?.flight_id) return;

  const pingChannel = async () => {
    try {
      const res = await axios.get(
        `${base_url.api1}/users/ping_channel?flight_id=${indivisualFlight.flight_id}`
      );
      // console.log(res);
    } catch (err) {
      console.log(err.message);
    }
  };

  const interval = setInterval(() => {
    pingChannel();
  }, 1000 * 60 * 7);

  return () => clearInterval(interval);

}, []);







  
 
 


   function getPastTimeDiffReadable(utcDateString) {
      const target = moment.utc(utcDateString);
      const now = moment.utc();
  
      let diffMinutes = now.diff(target, "minutes");
  
      if (diffMinutes < 1) {
        return "Just now";
      }
  
      if (diffMinutes < 60) {
        return `${diffMinutes} minutes ago`;
      }
  
      let diffHours = now.diff(target, "hours");
      if (diffHours < 24) {
        return `${diffHours} hours ago`;
      }
  
      let diffDays = now.diff(target, "days");
      return `${diffDays} days ago`;
  }
  

function calculateWithOffsetHours(
  departureLocal,
  departureOffsetHours,
  arrivalLocal,
  arrivalOffsetHours,
  currentUTC
) {
  const depOffsetMinutes = departureOffsetHours * 60;
  const arrOffsetMinutes = arrivalOffsetHours * 60;

  // FORCE neutral parsing in UTC
  const departureUTC = moment
    .utc(departureLocal)
    .subtract(depOffsetMinutes, "minutes");

  const arrivalUTC = moment
    .utc(arrivalLocal)
    .subtract(arrOffsetMinutes, "minutes");

  // Current UTC already has Z → force as UTC
  const currentTime = moment.utc(currentUTC);

  // Durations
  const totalMs = arrivalUTC.diff(departureUTC);
  const travelledMs = currentTime.diff(departureUTC);
  const remainingMs = arrivalUTC.diff(currentTime);

  const formatDuration = (ms) => {
    if (ms <= 0) return "0m";
    const minutes = Math.floor(ms / 60000);
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  };

  return {
    departureUTC: departureUTC.toISOString(),
    arrivalUTC: arrivalUTC.toISOString(),
    totalDuration: formatDuration(totalMs),
    travelled: formatDuration(travelledMs),
    remaining: formatDuration(remainingMs),
  };
}





const navigate = useNavigate()

  return (
    <div style={{padding:"10px"}}>


      <span className='live-tracking-close-btn'>
 <Close  onClick={() => {
                navigate(-1)
                 }} />
      </span>
      

      <h4 style={{textAlign:"center",fontSize:"18px",marginTop:"20px",fontWeight:"600"}}>Flight Live Tracking</h4>
             
               
      
              
                  <div
                    className="flight-data-container"
                    style={{ marginTop: "30px", }}
                  >
                   
                  
            
          
          <FlightRouteCard flight={indivisualFlight} viewMore={false} />
           {
            currentFlightPosition && currentFlightPosition.length > 0 && <div className='altitude-wrapper'>

              <div  className='altitude-left'>
                <AltitudeGraph
                positions={currentFlightPosition}
                progress={progress}
                />
                <div className='altitude-text'>
                  <span>Altitude</span>
                </div>
              </div>
 
              
            {
              indivisualFlight?.status === "A" &&  <div className='altitude-right'>

                <div className='altitude-heading'>

                  <span>
                    Heading
                  </span>
                  <span>
                   {heading}
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Altitude
                  </span>
                  <span>
                    {flightAltitude} ft
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Speed
                  </span>
                  <span>
                    {flightSpeed} mph
                  </span>
                </div>
                </div>
            }
             
              



            </div>

        }
        

        {
         ( indivisualFlight?.status === "A" || indivisualFlight?.status === "L" )  && currentFlightPosition && currentFlightPosition.length > 0 &&
           <div className='altitude-wrapper two-grid'>

             
 
               <div className='altitude-right'>

                <div className='altitude-heading'>

                  <span>
                    Total Duration
                  </span>
                  <span>
                   {totalDuration ?? "N/A"}
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Elapsed
                  </span>
                  <span>
                    {totalTraveledDuration ?? "N/A"}
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Remaining
                  </span>
                  <span>
                    {remainingDuration ?? "N/A"}
                  </span>
                </div>
                </div>
            
              <div className='altitude-right'>

                <div className='altitude-heading'>

                  <span>
                    Total Distance
                  </span>
                  <span>
                   {distance} mi
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Flown
                  </span>
                  <span>
                    {totalTraveledDistance} mi
                  </span>
                </div>

                 <div className='altitude-heading'>

                  <span>
                    Remaining
                  </span>
                  <span>
                     {remainingDistance } mi
                  </span>
                </div>
                </div>
            
             
              



            </div>

          }
      
                    {/* <div className="flight-data-refresh-wrapper">
                      {currentFlightPosition.length > 0 ? (
                        <span className="last-updated">
                          Updated{" "}
                          {getPastTimeDiffReadable(currentFlightPosition[0]?.date)}{" "}
                        </span>
                      ) : (
                        <span></span>
                      )}
      
            {currentFlightPosition.length > 0 && indivisualFlight?.status === "A" &&
              <span
                className="refresh-btn"
                onClick={() => handleRefresh()}
              >
              <IconRotateClockwise size={"14px"} className={backdropOpen ? 'rotate-btn' :""
                } /> {backdropOpen ? "Refreshing" :"Refresh"}
              </span>
            
            }
          </div> */}
          

          {/* {
            currentFlightPosition && currentFlightPosition.length > 0 ?  <FlightMap
                      airports={airports}
                      currentFlightPosition={currentFlightPosition}
                      heading={heading}
          /> : <div className='altitude-wrapper' style={{padding:"80px 30px"}}>
              <span className='value' style={{textAlign:"center"}}>Flight live Preview Not Available</span>
              </div>
          } */}
        

         <FlightMap
                      airports={airports}
                      currentFlightPosition={currentFlightPosition}
                      heading={heading}
          />


                   
                  </div>
               
    </div>
  )
}

export default FlightStatsDetails